import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styles: [
  ]
})
export class Page404Component implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {
  }
}
